import firstSacaiExperience from "./first-sacai-experience";
import firstCommeDesGarconsExperience from "./first-comme-des-garcons-experience";
import firstCommeDesGarconsHommePlusExperience from "./first-comme-des-garcons-homme-plus-experience";
import firstMaisonMargielaExperience from "./first-maison-margiela-experience";
import firstJunyaWatanabeExperience from "./first-junya-watanabe-experience";
import firstNoirKeiNinomiyaExperience from "./first-noir-kei-ninomiya-experience";
import firstRafSimonsExperience from "./first-raf-simons-experience";
import firstRickOwensExperience from "./first-rick-owens-experience";
import firstIsseyMiyakeExperience from "./first-issey-miyake-experience";
import firstYohjiYamamotoExperience from "./first-yohji-yamamoto-experience";
import firstPradaExperience from "./first-prada-experience";
import firstPleatsPleaseIsseyMiyakeExperience from "./first_pleats_please_issey_miyake_experience"

export const guideArticles = [
  firstSacaiExperience,
  firstCommeDesGarconsExperience,
  firstCommeDesGarconsHommePlusExperience,
  firstMaisonMargielaExperience,
  firstJunyaWatanabeExperience,
  firstNoirKeiNinomiyaExperience,
  firstRafSimonsExperience,
  firstRickOwensExperience,
  firstIsseyMiyakeExperience,
  firstYohjiYamamotoExperience,
  firstPradaExperience,
  firstPleatsPleaseIsseyMiyakeExperience,
];
